import api from './api';

export const consultarNovidades = () => api.get('/novidades').then(({ data }) => data);
export const registrarLeitura = (versaoId) => api.post('/novidades/lida', { versaoId });
